import { toast } from 'react-toastify'
import { theseus } from '../../api/theseus'

export async function verifyUserWithDynamicJwt(
  dynamicJwt: string,
  otherAguments = {},
) {
  const defaultFail = { user: null }
  try {
    const {
      data: { user },
    } = await theseus.post(`/auth/b2c/login`, {
        dynamicJwt,
      ...otherAguments,
    })
    if (!user) throw new Error('User not found')
    return { user }
  } catch (err) {
    console.error(err)
    toast.error('There was an error verifying your wallet address')
    return defaultFail
  }
}

export function formatSignCopy(signCopy: string, address: string) {
  return `${signCopy}\n\nI verify I am the owner of ${address}`
}
